import { render } from "./invoiceFormFields.vue?vue&type=template&id=5ac71242"
import script from "./invoiceFormFields.vue?vue&type=script&lang=js"
export * from "./invoiceFormFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__